<p-toast></p-toast>
<div class="p-col-12 p-d-flex p-d-inline-flex p-jc-between p-ai-center pb-0">
  <div class="p-d-flex p-d-inline-flex">
    <div *ngFor="let reseauSocial of reseauxSociaux" class="navItem" style="padding-right: 10px; padding-left: 10px;" ><a class="socialLink" [href]="reseauSocial.url"><i [class]="reseauSocial.icon"></i></a></div>
  </div>
  <div class="p-d-flex p-d-inline-flex">
    <div class="navItem" style="padding-right: 50px;" (click)="clickToClipboard(false)"><i class="pi pi-phone"></i><span class="p-d-none p-d-md-inline-flex p-pl-1">{{ phone }}</span></div>
    <div class="navItem" (click)="showMenuLang = !showMenuLang">
      <img class="iconLang" src="{{ current_lang.image }}" height="16">
      <div class="menuLang" *ngIf="showMenuLang">
        <div *ngFor="let lang of langues" class="langItem" (click)="changeLang(lang.locale); showMenuLang = false;"><img class="iconLang" src="{{ lang.image }}" height="16" alt="{{ lang.title }}"> {{ lang.title | translate }}</div>
      </div>
    </div>
  </div>
</div>
<div class="p-mb-2 p-mt-2">
  <div class="p-d-flex p-jc-center">
    <img src="assets/images/logo.png" height="150">
  </div>
  <div class="slogan p-d-flex p-jc-center">
    <span [innerHTML]="'slogan' | translate"></span>
  </div>
</div>
<p-divider></p-divider>
<app-navbar></app-navbar>
<p-divider></p-divider>
<router-outlet></router-outlet>
<p-divider></p-divider>
<div class="p-d-flex p-jc-around p-mt-2 p-flex-wrap">
  <div *ngFor="let partner of partners">
    <a [href]="partner.url" target="_blank" rel="noopener noreferrer">
      <img [src]="partner.icon" [alt]="partner.name" height="40">
    </a>
  </div>
</div>
<p-divider></p-divider>
<div class="p-d-flex p-flex-column">
  <div class="p-d-flex p-jc-center"><a routerLink="/confidentiality">{{ 'confidentiality.title' | translate }}</a></div>
  <div class="p-d-flex p-jc-center"><p>Copyright &copy; 2020 - {{ current_year }}</p></div>
</div>
